// Modern App.jsx with React Router and new design
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/layout/Header/Header';
import Footer from './components/layout/Footer/Footer';
import OnlineProgramAnnouncement from './components/ui/OnlineProgramAnnouncement/OnlineProgramAnnouncement';
import ScrollToTop from './components/ui/ScrollToTop/ScrollToTop';
import WhatsAppButton from './components/ui/WhatsAppButton/WhatsAppButton';
import './App.css';
import { HelmetProvider } from 'react-helmet-async';

const HomePage = lazy(() => import('./pages/HomePage/HomePage'));
const CoursesPage = lazy(() => import('./pages/CoursesPage/CoursesPage'));
const PlacementsPage = lazy(() => import('./pages/PlacementsPage/PlacementsPage'));
const AboutPage = lazy(() => import('./pages/AboutPage/AboutPage'));
const ContactPage = lazy(() => import('./pages/ContactPage/ContactPage'));
const TermsConditionsPage = lazy(() => import('./pages/TermsConditionsPage/TermsConditionsPage'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage/PrivacyPolicyPage'));
const CourseLandingPage = lazy(() => import('./pages/CourseLandingPages/CourseLandingPage'));
const OnlineLearningPage = lazy(() => import('./pages/OnlineLearningPage/OnlineLearningPage'));
const BlogPage = lazy(() => import('./pages/BlogPage/BlogPage'));
const Analytics = lazy(() => import('@vercel/analytics/react').then((module) => ({ default: module.Analytics })));
const SpeedInsights = lazy(() => import('@vercel/speed-insights/react').then((module) => ({ default: module.SpeedInsights })));

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="app">
          <Header />
          <AnimatePresence mode="wait">
            <motion.main
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Suspense fallback={null}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/students-work" element={<CoursesPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/placements" element={<PlacementsPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/terms-conditions" element={<TermsConditionsPage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                  <Route path="/online-learning" element={<OnlineLearningPage />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/blog/:slug" element={<BlogPage />} />
                  <Route path="/courses/:courseSlug" element={<CourseLandingPage />} />
                </Routes>
              </Suspense>
            </motion.main>
          </AnimatePresence>
          <Footer />
          <OnlineProgramAnnouncement />
          <ScrollToTop />
          <WhatsAppButton />
        </div>
      </Router>
      <Suspense fallback={null}>
        <Analytics />
        <SpeedInsights />
      </Suspense>
    </HelmetProvider>
  );
}

export default App;